<template>
  <!--  style="justify-content: space-between; align-items: center; " -->
  <div class="flex"
       style="width: 100%;  padding: 0 20px; box-sizing: border-box;justify-content: space-between;">
    <div class="flex">
      <p class="count_num" style="margin-right: 10px;">共计：<span style="font-weight: 700">{{ count }}条记录</span>，每页显示<span
          style="font-weight: 700">{{ length_num }}</span>条记录</p>
      <p class="count_num" v-if="total_order_price">共计消费金额：￥{{ total_order_price }}</p>
    </div>
    <el-pagination :current-page="page" @current-change="currentTab" background layout="prev, pager, next, jumper"
                   :total="total_page * 10">
      <!-- hide-on-single-page -->
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    total_page: Number,
    count: Number,
    // length_num: Number,
    total_order_price: {
      type: [String, Number],
      default: ''
    },
    page: Number,
    length_num: {
      type: Number,
      default: 10
    }
  },
  methods: {
    // 切换页
    currentTab(val) {
      // console.log(val);
      // this.page = val
      // this.ListFn()
      // this.TabCheck()
      this.$emit('pageChange', val)
    },
    // 上一页
    prevClick() {

    },
    // 下一页
    nextClick() {

    },
  },
}
</script>

<style lang=scss scoped>
.count_num {
  font-size: 16px;
}
</style>